import { render } from "./AddEditarticleList.vue?vue&type=template&id=2e341170&scoped=true"
import script from "./AddEditarticleList.vue?vue&type=script&lang=js"
export * from "./AddEditarticleList.vue?vue&type=script&lang=js"

import "./AddEditarticleList.vue?vue&type=style&index=0&id=2e341170&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e341170"]])

export default __exports__